<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('companies.link_company')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('companies.entity_name', 1)}}</label>
              <el-form-item prop="company">
                <base-el-select ref="companiesSelect" class="w-full" :options="companies" v-model="form.companies" multiple filterable :disabled="isLoadingSelect"
                  @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div>
        <base-button 
          class="w-full"
          mode="secondary-phantom-blue"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="$refs.companiesSelect.selectAll()"
          :loading="isLoadingSelect"
          />
        <base-button 
          class="w-full"
          v-else :text="$t('app.unselect_all')" 
          mode="secondary-phantom-blue"
          @click="$refs.companiesSelect.unselectAll()"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
      </div>
      <div  class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
// import { companies } from '@/services/app/getCompanies'
import { getAllCompanies } from '@/services/companies/getAllCompanies'

export default
{
  name: 'certificate-link-company-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    certificate: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        companies: []
      },
      companies: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getAllCompanies({ idCliente: this.$route.params.idCliente })
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.CIFSEmpresa.forEach(row => {
        this.companies.push({ value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.RazonSocial })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.companies === undefined || this.companies === null || this.companies.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.companies.length === this.form.companies.length) return true
      else return false
    }
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.companies = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', [this.form.companies])
      this.form.companies = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
